﻿import * as eventTypes from '../map/utils/eventTypes';
import * as actionTypes from '../map/utils/actionTypes';
import * as layerTypes from '../map/utils/layerTypes';
import Contextual from './controls/contextual/contextual';
export default class FeatureActionHandler {
    constructor(mapControl, classId, mapContainer, generalSettingsHandler, rootURL, resourcesHandler, addLayers, editControl, multipleAddLayers) {
        this.mapControl = mapControl;
        this.classId = classId;
        this.mapContainer = mapContainer;
        this.generalSettingsHandler = generalSettingsHandler;
        this.rootURL = rootURL;
        this.resourcesHandler = resourcesHandler;
        this.addLayers = addLayers;
        this.multipleAddLayers = multipleAddLayers;
        this.editControl = editControl;
        this.featureMenuElementId = 'xpmap-feature-menu-wrapper-' + this.mapControl.mapId + '-' + this.classId;
        this.featureInfoWrapper = 'xpmap-feature-info-wrapper-' + this.mapControl.mapId + '-' + this.classId;
        this.cancelFeatureInfoId = 'xpmap-cancel-feature-info-' + this.mapControl.mapId + '-' + this.classId;
        this.featureInfoContainer = 'xpmap-feature-info-container-' + this.mapControl.mapId + '-' + this.classId;
        this.contextMenu = null;
        this.disabled = false;
        this.contextMenuFeatureId = null;
        this.contextMenuLayerId = null;
        this.actionItems = {};
    }

    init() {
        this.mapContainer.append(this._getFeatureMenuTemplate());
        $event.register(eventTypes.FEATURE_SELECTION_CHANGED, this._getFeatureSelectionChangedHandler(), this, this.classId);
        $event.register(eventTypes.RIGHT_CLICK, this._getMouseRightClickActionHandler(), this, this.classId);
        $event.register(eventTypes.MAP_MULTIPLE_LAYER_SELECTION, this._getMultipleLayerSelectionHandler(), this, this.classId);
        $event.register(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, this._getFeatureToolsVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.CLEAR_MULTIPLE_SELECTION, this._getClearMultipleSelectionHandler(), this, this.classId);
    }

    _getClearMultipleSelectionHandler() {
        let handler = (eventName, event, sender) => {
            this._hideMultipleSelection();
        };

        return handler;
    }

    _getFeatureToolsVisibilityChangedHandler() {
        let handler = (eventName, event, sender) => {
            if (event.visible) {
                this._removeContextMenu();
                this.disabled = true;
            } else {
                this.disabled = false;
            }
        };

        return handler;
    }

    _getMouseRightClickActionHandler() {
        if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {

            var handler = (eventName, data, sender) => {
                if (this.selectedFeatureId != null) {
                    this.contextMenu = this._showContextMenu(data.originalEvent);
                }
            };

            return handler;
        }

        return function (eventName, event, sender) { };
    }

    _showContextMenu(event) {
        if (this.disabled) {
            return null;
        }

        this.contextMenuFeatureId = this.selectedFeatureId;
        this.contextMenuLayerId = this.selectedFeatureLayerId;

        var items = [];

        this._extractFeatureActions(this.selectedFeatureLayerId, this.selectedFeatureLayer).then(() => {
            var customActionsItems = this.actionItems["layer-" + this.selectedFeatureLayerId.toString()];

            var selectedFeatures = this.mapControl.getAllSelectedFeatures(this.selectedFeatureLayerId);

            if (customActionsItems != null) {
                for (var i = 0; i < customActionsItems.length; i++) {
                    if (customActionsItems[i].minSelection <= selectedFeatures.length && customActionsItems[i].maxSelection >= selectedFeatures.length) {
                        items.push({
                            label: this.resourcesHandler.get(customActionsItems[i].name),
                            cssIcon: customActionsItems[i].icon,
                            onClick: customActionsItems[i].callback
                        });
                    }
                }
            }

            var selectionCount = selectedFeatures.length;

            if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {
                if (selectionCount > 1) {
                    items.push({
                        label: this.resourcesHandler.get("Fit elements"),
                        cssIcon: 'fal fa-compress-arrows-alt',
                        onClick: (itemKey, opt, e) => {
                            if (this.selectedFeatureId != null) {
                                this.mapControl.showSelectedFeatures(this.selectedFeatureLayerId);
                            }
                        }
                    });

                    if (this.multipleAddLayers != null && this.multipleAddLayers.length > 0) {
                        items.push({
                            label: this.resourcesHandler.get("CopyToLayer"),
                            cssIcon: 'fal fa-copy',
                            onClick: (itemKey, opt, e) => {
                                if (this.selectedFeatureId != null) {
                                    this._handleCopyToLayerMultiple(this.selectedFeatureLayerId);
                                }
                            }
                        });
                    }
                } else {
                    if (this.addLayers != null && this.addLayers.length > 0) {
                        items.push({
                            label: this.resourcesHandler.get("CopyToLayer"),
                            cssIcon: 'fal fa-copy',
                            onClick: (itemKey, opt, e) => {
                                if (this.selectedFeatureId != null) {
                                    this._handleCopyToLayer(this.selectedFeatureLayerId);
                                }
                            }
                        });
                    }

                    if (this.selectedFeatureLayerId == layerTypes.MEASUREMENTS || this.selectedFeatureLayerId == layerTypes.REDLINE || this.selectedFeatureLayerId == layerTypes.DIMENSIONING) {
                        items.push({
                            label: this.resourcesHandler.get("EDIT_LAYER_GEOMETRY"),
                            cssIcon: 'fal fa-pencil-ruler',
                            onClick: (itemKey, opt, e) => {
                                if (this.selectedFeatureId != null) {
                                    this._handleEditTemporaryVectorFeature(this.selectedFeatureLayerId, this.selectedFeatureId);
                                }
                            }
                        });
                    }

                    items.push({
                        label: this.resourcesHandler.get("Feature Information"),
                        cssIcon: 'fal fa-info-circle',
                        onClick: (itemKey, opt, e) => {
                            if (this.selectedFeatureId != null) {
                                this._showFeatureInfo(this.selectedFeatureLayerId, this.selectedFeatureId);
                            }
                        }
                    });

                    items.push({
                        label: this.resourcesHandler.get("Fit element"),
                        cssIcon: 'fal fa-compress-arrows-alt',
                        onClick: (itemKey, opt, e) => {
                            if (this.selectedFeatureId != null) {
                                this.mapControl.fitFeature(this.selectedFeatureLayerId, this.selectedFeatureId);
                            }
                        }
                    });
                }

                items.push({ type: 'seperator' });
            }

            if (selectionCount > 1) {
                items.push({
                    label: this.resourcesHandler.get("Clear selections"),
                    cssIcon: 'fal fa-times-square',
                    onClick: (itemKey, opt, e) => {
                        this.mapControl.clearSelection();
                    }
                });
            } else {
                items.push({
                    label: this.resourcesHandler.get("Clear selection"),
                    cssIcon: 'fal fa-times-square',
                    onClick: (itemKey, opt, e) => {
                        this.mapControl.clearSelection();
                    }
                });
            }

            if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.CLICK || this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.DOUBLE_CLICK) {
                if (customActionsItems != null && customActionsItems.length > 0 && items.length > 1) {
                    $event.notify("contextMenuVisibilityChanged", { visible: true }, this, this.classId);
                    return new Contextual({
                        isSticky: false,
                        minWidth: '250px',
                        width: 'auto',
                        target: this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT ? null : this.mapControl.id,
                        owner: this,
                        event: event,
                        items: items
                    });
                } else {
                    return null;
                }
            } else {
                return new Contextual({
                    isSticky: false,
                    minWidth: '250px',
                    width: 'auto',
                    target: this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT ? null : this.mapControl.id,
                    owner: this,
                    event: event,
                    items: items
                });
            }
        });
    }

    _handleEditTemporaryVectorFeature(selectedFeatureLayerId, selectedFeatureId) {
        this.mapControl.generalActionHandler.startEdit(selectedFeatureLayerId, [this.mapControl.getFeatureById(selectedFeatureLayerId, selectedFeatureId)]);
        this._removeContextMenu();
    }

    _showFeatureInfo(selectedFeatureLayerId, selectedFeatureId) {
        document.getElementById(this.featureMenuElementId).innerHTML = this._getFeatureInfoTemplate();

        let feature = this.mapControl.getFeatureById(selectedFeatureLayerId, selectedFeatureId);

        if (feature != null) {
            let properties = feature.getProperties();

            let keys = Object.keys(properties);

            let template = ``;

            keys.forEach(key => {
                let item = properties[key];

                if (item != null && item.getExtent != null) {
                    template += `<div class="form-row col-12"><label>Geometry Type: </label><label>` + item.getType() + `</label></div>`;
                } else {
                    template += `<div class="form-row col-12"><label>` + key + `: </label><label>` + item + `</label></div>`;
                }
            });

            document.getElementById(this.featureInfoContainer).innerHTML = template;
        }

        document.getElementById(this.cancelFeatureInfoId).addEventListener('click', () => {
            document.getElementById(this.featureMenuElementId).innerHTML = '';
        });
    }

    _extractFeatureActions(layerId, layer) {
        if (this.actionItems["layer-" + layerId] == null) {
            this.actionItems["layer-" + layerId] = [];

            if (layerId == layerTypes.MEASUREMENTS || layerId == layerTypes.REDLINE || layerId == layerTypes.DIMENSIONING) {
                return new Promise((resolve, reject) => {
                    resolve();
                });
            } else {
                let getLayerActionsUrl = this.rootURL + 'Map/GetLayerElementActions?idMap=' + this.mapControl.mapId + '&idMapLayer=' + layerId;
                var data = {};
                data.otherParams = layer.get('otherParams');

                return new Promise((resolve, reject) => {
                    $.ajax({
                        type: "POST",
                        url: getLayerActionsUrl,
                        async: false,
                        data: JSON.stringify(data),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null && result.length > 0) {
                                result.forEach(actionItem => {
                                    this.actionItems["layer-" + layerId].push(this._getStandardActionItem(actionItem));
                                });
                            }
                            resolve();
                        },
                        error: (e) => {
                            resolve();
                        }
                    });
                });
            }
        } else {
            return new Promise((resolve, reject) => {
                resolve();
            });
        }
    }

    _getStandardActionItem(actionConfig) {
        const config = actionConfig;
        var actionHandler = (itemKey, opt, e) => {
            if (config.SubType == "EDIT_LAYER_GEOMETRY") {
                this.mapControl.generalActionHandler.startEdit(config.IdMapLayer);
                this._removeContextMenu();
            }
            else if (config.SubType == "DELETE") {
                confirmDialog.fire({
                    title: this.resourcesHandler.get('DeleteItemTitle'),
                    text: this.resourcesHandler.get('DeleteItemContent'),
                }).then((result) => {
                    if (result.value) {
                        var featureInfo = null;
                        if (this.selectedFeatureId != null) {
                            var featureInfo = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                            if (featureInfo != null) {
                                featureInfo.layerId = this.selectedFeatureLayerId;
                                this.mapControl.removeFeatures([featureInfo]);
                            }
                        }
                        else {
                            this.mapControl.removeFeatures(this.mapControl.getAllSelectedFeatureDetails(config.IdMapLayer));
                        }
                    }
                });
            }
            else if (config.SubType == 'EDIT') {
                var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal&idForm=' + config.IdFormTarget + '&pkVal=';

                if (this.selectedFeatureId == null) {
                    return;
                }

                _url += this.selectedFeatureId;
                _url += '&idApp=' + xapp.currentApp;

                var layer = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);
                if (layer != null && layer.IdExtConn != null) {
                    _url += "&IdExtConn=" + layer.IdExtConn;
                }
                var data = null;
                if (config.OtherParams != null) {
                    var postData = {};
                    postData.otherParams = config.OtherParams;
                    data = JSON.stringify(postData);
                }
                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height, data);
            }
            else if (config.SubType == 'FormWf') {
                if (this.selectedFeatureId == null) {
                    return;
                }

                var _url = this.rootURL + 'UIAction/GetFormWFRun?idAction=' + config.Id;

                if (config.Content != null && config.Content.trim() != '') {
                    let paramsMap = JSON.parse(config.Content);
                    let params = {};
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    if (paramsMap.length > 0) {
                        paramsMap.forEach(param => {
                            params[param] = selectedFeature.get(param);
                        });
                    }

                    _url += '&parameters=' + JSON.stringify(params);
                } else {
                    let paramsMap = this.getURLParams(config.Url);
                    let params = {};
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    if (paramsMap.length > 0) {
                        paramsMap.forEach(param => {
                            params[param] = selectedFeature.get(param);
                        });
                    }

                    _url += '&parameters=' + JSON.stringify(params);
                }

                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height);
            }
            else if (config.SubType == 'URL') {
                if (this.selectedFeatureId == null) {
                    return;
                }

                let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                let _url = config.Url;

                if (selectedFeature != null) {
                    let propertyKeys = Object.keys(selectedFeature.getProperties());

                    propertyKeys.forEach(key => {
                        let keyValue = selectedFeature.get(key);

                        if (keyValue != null) {
                            _url = _url.replaceAll('{' + key + '}', keyValue);
                        }
                    });
                }

                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                showModalWindow(_url, config.Text, config.Icon, width, height);
            }
            else if (config.SubType == 'FORM') {
                let width = null;
                let height = null;

                if (config.UiContent != null && config.UiContent.trim() != '') {
                    let uiContent = JSON.parse(config.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                if (this._checkMobile()) {
                    width = '100%';
                    height = '100%';
                }

                if (this.selectedFeatureId == null) {
                    return;
                }

                var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal';
                var needFields = false;

                //idform
                if (config.IdFormTarget != null && config.IdFormTarget != '') {
                    _url += '&idForm=' + config.IdFormTarget;
                } else {
                    needFields = true;
                }

                var layer = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);
                if (layer != null && layer.IdExtConn != null) {
                    _url += "&IdExtConn=" + layer.IdExtConn;
                }

                let selectedFeaturesIds = this.mapControl.getAllSelectedFeatures(this.selectedFeatureLayerId);

                if (config.NewRecord) {
                    //nothing to do
                }
                else if (selectedFeaturesIds != null && selectedFeaturesIds.length > 1) {
                    let ids = [];

                    selectedFeaturesIds.forEach(feature => {
                        ids.push(feature.getId());
                    });

                    window.featuresToBeProcessed = { features: ids, layerId: this.selectedFeatureLayerId };
                    _url += '&fromActionType=EDIT_MULTI';
                }
                else {
                    if (config.IdFieldTarget != null) {
                        needFields = true;
                    }
                    else {
                        _url += '&pkVal=' + this.selectedFeatureId;
                    }
                }
                _url += '&idaction=' + config.Id;
                // + '&pkValCurrent=' + this.selectedFeatureId;
                //'&idForm=' + config.IdFormTarget + '&pkVal=';
                _url += '&idApp=' + xapp.currentApp;
                if (needFields) {
                    let selectedFeature = this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId);
                    let layerSettings = this.mapControl.layerSettingsHandler.getLayerSettings(this.selectedFeatureLayerId);

                    let getFieldsUrl = this.rootURL + 'Entity/GetFields?id=' + layerSettings.Entity.Id;

                    $.ajax({
                        type: "GET",
                        url: getFieldsUrl,
                        async: false,
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            var entityFields = result;

                            if (config.IdFormFieldTarget != null && config.IdFormFieldTarget != '') {
                                var possibilities = entityFields.filter(row => { return row.Id == config.IdFormFieldTarget });
                                if (possibilities.length > 0) {
                                    var entityField = possibilities[0];
                                    _url += '&idForm=' + selectedFeature.get(entityField.FieldName);
                                }
                            }
                            if (config.IdFieldTarget != null && config.IdFieldTarget != '') {
                                var possibilities = entityFields.filter(row => { return row.Id == config.IdFieldTarget });
                                if (possibilities.length > 0) {
                                    var entityField = possibilities[0];
                                    _url += '&pkVal=' + selectedFeature.get(entityField.FieldName);
                                }
                            }
                            showModalWindow(_url, config.Text, config.Icon, width, height);
                        },
                        error: (e) => {
                            toastr.error(this.getResource('GetFieldError'));
                        }
                    });
                }
                else {
                    showModalWindow(_url, config.Text, config.Icon, width, height);
                }
            } else if (config.SubType == 'JS') {
                //TODO
                //window['map_layer_action_' + config.Id + '_onClick'](this.mapControl.getFeatureDetails(this.selectedFeatureLayerId, this.selectedFeatureId));
            }
        }

        var maximumSelection = (actionConfig.MaxSel != null && actionConfig.MaxSel != '') ? actionConfig.MaxSel : Number.MAX_SAFE_INTEGER;
        var minimumSelection = (actionConfig.MinSel != null && actionConfig.MinSel != '') ? actionConfig.MinSel : 1;

        var item = {
            icon: actionConfig.Icon,
            name: this.resourcesHandler.get(actionConfig.Text),
            callback: actionHandler,
            maxSelection: maximumSelection,
            minSelection: minimumSelection
        }

        return item;
    }

    _getMultipleLayerSelectionHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                this._handleMultipleLayerSelection(data.features);
            }
        };

        return handler;
    }

    _handleCopyToLayer(selectedFeatureLayerId) {
        this._initModal(this.resourcesHandler.get('SelectTargetLayer'), '40%', 'auto', null, false);
        $('body').css('overflow', 'hidden');
        $('#multiple-layer-selection-modal-inner')[0].innerHTML = '';
        $('#multiple-layer-selection-modal-inner').append('<div id="multiple-layer-selection-tree" style="overflow-x: hidden;"></div>');

        let treeData = [];
        let entityDetailsRequests = [];

        this.addLayers.forEach(action => {
            let layerSettings = this.mapControl.getLayerSettings(action.IdMapLayer);
            let entity = layerSettings.Entity;
            let sld = this.mapControl.getLayerStyle(action.IdMapLayer);
            let imageStyleUrl = null;

            if (sld != null) {
                let rules = sld.style.rules;
                if (rules != null & rules.length > 0) {
                    imageStyleUrl = this._getLegendImageURL(layerSettings, rules[0].name);
                }
            }

            treeData.push({
                name: this.resourcesHandler.get(layerSettings.Title),
                entityId: entity.Id,
                layerId: action.IdMapLayer,
                fid: action.IdMapLayer,
                type: 'layer',
                currentIdx: 1,
                imageStyleUrl: imageStyleUrl,
                action: action
            });

            entityDetailsRequests.push(this._getEntityDetails(entity.Id));
        });

        var dataSource = new kendo.data.HierarchicalDataSource({
            data: treeData,
            schema: {
                model: {
                    children: "items"
                }
            }
        });

        $('#multiple-layer-selection-tree').kendoTreeView({
            loadOnDemand: false,
            dataSource: dataSource,
            dragAndDrop: false,
            dataTextField: 'name',
            template: (e) => {
                let item = e.item;
                let template = '<div class="legend-node" style="width:15rem;">';

                if (item.imageStyleUrl != null) {
                    template += '<img src="' + item.imageStyleUrl + '" style="width:auto; height:19px;">';
                }

                template += '<div class="ml-2" style="display: inline-table;  height: 1rem; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '">' + item.name + '</div>';

                template += '</div>';

                return template;
            },
            select: (e) => {
                let selectedItem = $('#multiple-layer-selection-tree').data('kendoTreeView').dataItem(e.node);
                this.editControl.startEdit(selectedItem.layerId, selectedItem.action, null, null, this.mapControl.getAllSelectedFeatures(selectedFeatureLayerId));
                this.mapControl.refreshLayer(selectedFeatureLayerId);
                setTimeout(() => {
                    this._closeModal();
                }, 100);
            }
        });

        $('#multiple-layer-selection-tree').css('border', 'none');
        $('#multiple-layer-selection-tree').data("kendoTreeView").expand(".k-treeview-item");

        setTimeout(() => {
            this._centerModal();
        }, 100);
    }

    _handleCopyToLayerMultiple(selectedFeatureLayerId) {
        this._initModal(this.resourcesHandler.get('SelectTargetLayer'), '40%', 'auto', null, false);
        $('body').css('overflow', 'hidden');
        $('#multiple-layer-selection-modal-inner')[0].innerHTML = '';
        $('#multiple-layer-selection-modal-inner').append('<div id="multiple-layer-selection-tree" style="overflow-x: hidden;"></div>');

        let treeData = [];
        let entityDetailsRequests = [];

        this.multipleAddLayers.forEach(action => {
            let layerSettings = this.mapControl.getLayerSettings(action.IdMapLayer);
            let entity = layerSettings.Entity;
            let sld = this.mapControl.getLayerStyle(action.IdMapLayer);
            let imageStyleUrl = null;

            if (sld != null) {
                let rules = sld.style.rules;
                if (rules != null & rules.length > 0) {
                    imageStyleUrl = this._getLegendImageURL(layerSettings, rules[0].name);
                }
            }

            treeData.push({
                name: this.resourcesHandler.get(layerSettings.Title),
                entityId: entity.Id,
                layerId: action.IdMapLayer,
                fid: action.IdMapLayer,
                type: 'layer',
                currentIdx: 1,
                imageStyleUrl: imageStyleUrl,
                action: action
            });

            entityDetailsRequests.push(this._getEntityDetails(entity.Id));
        });

        var dataSource = new kendo.data.HierarchicalDataSource({
            data: treeData,
            schema: {
                model: {
                    children: "items"
                }
            }
        });

        $('#multiple-layer-selection-tree').kendoTreeView({
            loadOnDemand: false,
            dataSource: dataSource,
            dragAndDrop: false,
            dataTextField: 'name',
            template: (e) => {
                let item = e.item;
                let template = '<div class="legend-node" style="width:15rem;">';

                if (item.imageStyleUrl != null) {
                    template += '<img src="' + item.imageStyleUrl + '" style="width:auto; height:19px;">';
                }

                template += '<div class="ml-2" style="display: inline-table;  height: 1rem; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '">' + item.name + '</div>';

                template += '</div>';

                return template;
            },
            select: (e) => {
                let selectedItem = $('#multiple-layer-selection-tree').data('kendoTreeView').dataItem(e.node);
                this.editControl.startEdit(selectedItem.layerId, selectedItem.action, null, null, this.mapControl.getAllSelectedFeatures(selectedFeatureLayerId));
                this.mapControl.refreshLayer(selectedFeatureLayerId);
                setTimeout(() => {
                    this._closeModal();
                }, 100);
            }
        });

        $('#multiple-layer-selection-tree').css('border', 'none');
        $('#multiple-layer-selection-tree').data("kendoTreeView").expand(".k-treeview-item");

        setTimeout(() => {
            this._centerModal();
        }, 100);
    }

    _handleMultipleLayerSelection(features) {
        $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
        $('.toolbar-selected-items-wrapper').append('<div id="multiple-layer-selection-tree" style="overflow-x: hidden; min-width: 17rem;"></div>');
        $('.map-toolbar-item.clear-selection').show();
        $(".map-toolbar-selection-list").addClass('joined');
        let structuredData = {};

        features.forEach(feature => {
            if (this.mapControl.selectionHandler.selectionHolder.layers[feature.layerId] != null) {
                if (structuredData[feature.layerId] == null) {
                    structuredData[feature.layerId] = {
                        name: this.resourcesHandler.get(this.mapControl.getLayerSettings(feature.layerId).Title),
                        entityId: this.mapControl.getLayerSettings(feature.layerId).Entity != null ? this.mapControl.getLayerSettings(feature.layerId).Entity.Id : null,
                        layerId: feature.layerId,
                        items: [],
                        fid: feature.layerId,
                        type: 'layer',
                        currentIdx: 1
                    }
                } else {
                    structuredData[feature.layerId].currentIdx++;
                }

                let featureClone = {};

                feature.getKeys().forEach(featureKey => {
                    featureClone[featureKey] = feature.get(featureKey);
                });

                featureClone.layerId = feature.layerId;
                featureClone.featureIdentifier = feature.get(this.mapControl.getLayer(feature.layerId).get("idField"));
                featureClone.name = structuredData[feature.layerId].name + ' ' + structuredData[feature.layerId].currentIdx;
                featureClone.originalFeature = feature;
                structuredData[feature.layerId].items.push(featureClone);
            }
        });

        let treeData = [];
        let entityDetailsRequests = [];

        Object.keys(structuredData).forEach(key => {
            if (structuredData[key].entityId){
                entityDetailsRequests.push(this._getEntityDetails(structuredData[key].entityId));
            }
        });

        Promise.all(entityDetailsRequests).then((result) => {
            if (result != null && result.length > 0) {
                result.forEach(resultItem => {
                    if (resultItem != null && resultItem.length > 0) {
                        let nameField = resultItem.filter(row => { return row.SpecialFieldType == 'NAME_FIELD' });

                        if (nameField != null && nameField.length > 0) {
                            let currentItemKeys = Object.keys(structuredData).filter(row => { return structuredData[row].entityId == resultItem[0].IdEntity });

                            if (currentItemKeys != null && currentItemKeys.length > 0) {
                                currentItemKeys.forEach(currentItemKey => {
                                    structuredData[currentItemKey].items.forEach(featureItem => {
                                        if (featureItem[nameField[0].FieldName] != null && featureItem[nameField[0].FieldName].toString().trim() != '') {
                                            featureItem.name = featureItem[nameField[0].FieldName].toString();
                                        }
                                    });
                                });
                            }
                        }
                    }
                });
            }

            Object.keys(structuredData).forEach(key => {
                let styleId = this.mapControl.getLayerSettings(key).IdDefaultStyle;
                let currentLayer = this.mapControl.getLayer(key);

                if (styleId != null && currentLayer != null) {
                    structuredData[key].items.forEach(item => {
                        let classIdx = 0;
                        if (currentLayer.getStyle && typeof currentLayer.getStyle == 'function') {
                            let symbols = currentLayer.getStyle()(item.originalFeature);
                            if (symbols.length > 0 && symbols[0].getZIndex() < 0) {
                                classIdx = -symbols[0].getZIndex();
                            }
                        }

                        item.imageStyleUrl = this._getStylePreview(styleId, classIdx);
                    });
                }

                treeData.push(structuredData[key]);
            });

            var dataSource = new kendo.data.HierarchicalDataSource({
                data: treeData,
                schema: {
                    model: {
                        children: "items"
                    }
                }
            });

            $('#multiple-layer-selection-tree').kendoTreeView({
                loadOnDemand: false,
                dataSource: dataSource,
                dragAndDrop: false,
                select: function (e) {
                    e.preventDefault();
                },
                dataTextField: 'name',
                template: (e) => {
                    let item = e.item;
                    let template = '<div class="legend-node" style="width:17rem;">';

                    if (item.imageStyleUrl != null) {
                        template += '<img src="' + item.imageStyleUrl + '" style="width:auto; height:19px;">';
                    }

                    if (item.type == 'layer') {
                        template += '<div data-layer="' + item.layerId + '" class="ml-2" style="display: flex; width: 98%; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '"><span style="margin-right: 0.5rem;">' + item.name + '</span>';

                        if (this.mapControl.selectionHandler.selectionHolder.allowMultiple) {
                            template += '<span class="btn btn-secondary fal fa-check-double ml-auto select-layer-btn" style="min-width: 1.25rem; width: 1.25rem; height: 1.25rem; line-height: 0.9rem; color: white; font-weight: 600;margin-right: -5px;"></span>';
                        }

                        template += '</div>';
                    } else {
                        template += '<div data-layer="' + item.layerId + '" data-feature="' + item.featureIdentifier + '" class="ml-2 data-feature" style="display: flex; width: 95%; font-size: 0.75rem; white-space: break-spaces;' + (item.currentIdx != null ? ' font-weight: 500 !important;' : ' font-weight: 400 !important;') + '"><span style="margin-right: 0.5rem;">' + item.name + '</span>';
                        template += '<span class="btn btn-secondary fal fa-check ml-auto select-feature-btn" style="min-width: 1.25rem; width: 1.25rem; height: 1.25rem; line-height: 0.9rem; color: white; font-weight: 600;"></span>';
                        template += '</div>';
                    }

                    template += '</div>';

                    return template;
                }
            });

            $('#multiple-layer-selection-tree').css('border', 'none');
            $('#multiple-layer-selection-tree').data("kendoTreeView").expand(".k-treeview-item");

            setTimeout(() => {
                $('.map-toolbar-selected-items').show();

                $('#multiple-layer-selection-tree .k-treeview-lines').children('.k-treeview-item').css('margin-bottom', '1rem');

                $('.select-layer-btn').on('click', (evt) => {
                    let currentTarget = evt.currentTarget;
                    let layerId = $(currentTarget).parent().attr('data-layer');
                    let featureIds = [];

                    let items = $(currentTarget).parent().parent().parent().parent().siblings('.k-treeview-group').find('.data-feature');
                    [...items].forEach(item => {
                        featureIds.push($(item).attr('data-feature'));
                    });

                    featureIds.forEach(featureId => {
                        this.mapControl.selectFeature(layerId, featureId, true, false, true);
                    });

                    setTimeout(() => {
                        this._hideMultipleSelection();
                        $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
                    }, 100);
                });

                $('.select-feature-btn').on('click', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).parent().attr('data-layer');
                    let featureId = $(currentTarget).parent().attr('data-feature');

                    if (this.mapControl.selectionHandler.selectionHolder.allowMultiple && !this.mapControl.selectionHandler.copyMode) {
                        if ($(currentTarget).hasClass('btn-primary')) {
                            $(currentTarget).removeClass('btn-primary');
                            $(currentTarget).addClass('btn-secondary');

                            this.mapControl.deselectFeature(layerId, featureId);
                            $(currentTarget).parent().attr('old-state', 0);
                        } else {
                            $(currentTarget).addClass('btn-primary');
                            $(currentTarget).removeClass('btn-secondary');

                            this.mapControl.selectFeature(layerId, featureId, true, false, true);
                            $(currentTarget).parent().attr('old-state', 2);
                        }
                    } else {
                        this.mapControl.selectFeature(layerId, featureId, true, false, true);
                        setTimeout(() => {
                            this._hideMultipleSelection();
                        }, 100);
                    }
                });

                $('.data-feature').on('mouseenter', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');

                    let oldState = this.mapControl.highlightFeature(layerId, featureId);
                    $(currentTarget).attr('old-state', oldState);
                });

                $('.data-feature').on('mouseleave', (evt) => {
                    let currentTarget = evt.currentTarget;

                    let layerId = $(currentTarget).attr('data-layer');
                    let featureId = $(currentTarget).attr('data-feature');

                    let oldState = $(currentTarget).attr('old-state');

                    if (oldState == null) {
                        oldState = 0;
                    }

                    this.mapControl.unhighlightFeature(layerId, featureId, oldState);
                });
            }, 100);
        });
    }

    _hideMultipleSelection() {
        $('.map-toolbar-selected-items').hide();
        if ($('.toolbar-selected-items-wrapper').length > 0) {
            $('.toolbar-selected-items-wrapper')[0].innerHTML = '';
        }
        $(".map-toolbar-selection-list").removeClass('joined');
    }

    _getStylePreview(styleId, classIdx) {
        var url = rootURL + 'img/style/' + styleId + '_' + classIdx + '.png';
        return url;
    }

    _getLegendImageURL(layerConfig, rule) {
        var url = rootURL + 'style/GetLegendGraphicNative?idMap=' + this.mapControl.mapId + '&idMapLayer=' + layerConfig.Id + '&ruleName=' + rule + '&width=24&height=24';
        return url;
    }

    _getEntityDetails(entityId) {
        let entityDetailsUrl = this.rootURL + 'Entity/GetFields?id=' + entityId;
        return $.ajax({
            type: "GET",
            url: entityDetailsUrl,
            contentType: "application/json; charset=utf-8"
        });
    }

    _initModal(title, height, width, url, isModal) {
        if ($('#multipleLayerSelectionModal').length == 0) {
            $('body').append('<div id="multipleLayerSelectionModal"></div>');
        }

        $('#multipleLayerSelectionModal').append('<div id="multiple-layer-selection-modal-inner" style="padding: 0.5rem 0rem !important; padding-left: 0.5rem !important;"></div>');

        if (this._checkMobile()) {
            width = '100%';
            height = 'auto';
            maxHeight = 'calc(100% - 3.8rem)';
        }

        let modalOptions = {
            draggable: true,
            resizable: true,
            width: width != null ? width : "auto",
            height: "auto",
            maxHeight: height,
            title: title,
            modal: isModal,
            close: () => { this._closeModal(); }
        };

        if (url != null) {
            modalOptions.content = {
                url: url
            };
        }

        $('#multiple-layer-selection-modal-inner').kendoWindow(modalOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    _centerModal() {
        $('#multiple-layer-selection-modal-inner').data("kendoWindow").center();
    }

    _closeModal() {
        $('#multiple-layer-selection-modal-inner').data("kendoWindow").destroy();
    }

    _getFeatureSelectionChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let selectedFeatures = data.features;
                this.selectedFeatureId = selectedFeatures == null ? null : selectedFeatures[0];
                this.selectedFeatureLayerId = data.layerId;
                this.selectedFeatureLayer = data.layer;

                if (this.selectedFeatureId == null || this.selectedFeatureLayerId == null) {
                    $(this.mapContainer).css({ "cursor": "default" });
                    if (this.contextMenu != null) {
                        this.contextMenu.hide();
                    }
                } else {
                    if (this.generalSettingsHandler.settings.FeatureActionMenuDisplayType == actionTypes.RIGHT) {
                        $(this.mapContainer).css({ "cursor": "url('" + this.rootURL + "img/cursor/cm.gif'), auto" });
                    }
                }
            }
        };

        return handler;
    }

    _removeContextMenu() {
        if (this.contextMenu != null) {
            this.contextMenu.hide();
            //if (this.currentActionType == actionTypes.CLICK || this.currentActionType == actionTypes.DOUBLE_CLICK) {
            //    $event.notify("contextMenuVisibilityChanged", { visible: false }, this);
            //}
        }
    }

    _getFeatureMenuTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<div class='feature-modal-wrapper' id="` + this.featureMenuElementId + `">
                        </div>`;
        return div.firstChild;
    }

    _getFeatureInfoTemplate() {
        return `<div class="general-settings-wrapper panel config-modal" id="` + this.featureInfoWrapper + `">
                    <div class="general-settings-panel panel-container feature-info-modal">
                        <div class="panel-content pt-2 pl-0 pr-0 pb-0">
                            <div class="form-row general-settings-title-row m-0">
                                <label class="form-label general-settings-title ml-3">` + this.resourcesHandler.get('Feature Information') + `</label>
                            </div>
                            <div class="form-row mb-0 p-4" id="` + this.featureInfoContainer + `" style="max-height: calc(80vh - 6rem); overflow-y: auto; width: calc(100% - -5px);">
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelFeatureInfoId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                        </div>
                    </div>
                </div>`;
    }
}